//URL for API in prodution and development
const prod = {
  url: {
    API_URL: "https://api.f3mmpds.app/api"
  }
};
const dev = {
  url: {
    API_URL: "http://api-mpds-beta.f3m.pt/api"
  }
};
//export const config = process.env.NODE_ENV === "development" ? dev : prod;
export const config = process.env.NODE_ENV === "development" ? dev : process.env.REACT_APP_ENV === "dev" ? dev : prod;

//Version
export const VERSION = "1.4.3"

//URLs API
export const CompatibleVersion = "/compatibleVersion";
export const Token = "/Login/Token";
export const GetInstitutions = "/Login/Institutions";
export const Logout = "/Logout";
export const InfoClient = "/Client";
export const InfoSpace = "/Client/UsedSpace";
export const Institution = "/Institution";
export const AllUsersAllInstitutions = "/Institutions/Users";
export const AddUserToInstitution = "/Institution/AddUser";
export const RemoverUserFromInstitution = "/Institution/RemoveUser";
export const InstitutionProfiles = "/Institution/Profiles";
export const IdentificationTypes = "/Institution/Patient/IdentificationTypes";
export const EstablishmentsByInstitutions = "/Institution/Establishments/user"
export const UpdateUserEstablishments = "/Institution/UpdateUserEstablishments"
export const User = "/User";
export const UserInstitution = "/User/Institution";
export const UserPhoto = "/User/Photo";
export const UserPhotoAdmin = "/User/UpdatePhoto";
export const UserProfile = "/User/Profile";
export const UserFetch = "/User/fetch";
export const ClearPassword = "/User/ResetPassword";
export const CardListView = "/User/CardListView";
export const ResetPassword = "/ResetPassword";
export const GetPatientInfo = "/Patient";
//export const PatientsSearch = "/Patient/Search";
export const PatientsSearch = "/allPatient/Search";
export const AllPatient = "/AllPatient";
export const GetMedication = "/Patient/Medication";
export const GetDiagnosis = "/Patient/Diagnosis";
export const GetInternments = "/Patient/Internments";
export const HistoryInterventions = "/Patient/HistoryInterventions";
export const HistoryInterventionsWithFilter =
  "/Patient/HistoryInterventionsWithFilter";
export const GetEpisodes = "/Patient/Episode/Patient";
export const GetUriUploadPhoto = "/Patient/UriToUploadPhoto";
export const PutPatient = "/Patient/";
export const PutPatientWithInternmentAndEpisode = "/PatientWithInternmentAndEpisode"
export const PatientEpisode = "/Patient/Episode";
export const PatientInternment = "/Patient/Internment";
export const StructureCardsPatient = "/StructureCardsPatient";
export const GetWoundById = "/wound";
export const WoundClose = "/wound/Close";
export const WoundOpen = "/wound/Open";
export const GetWoundsEpisodeAtual = "/Wound/Patient";
export const GetWounds = "/AllWound/Patient";
export const PutWoundsIntervention = "/Wound/Intervention";
export const WoundTypologies = "/Institution/WoundTypologies";
export const GetDashboard = "/Institution/StatisticsDashboard";
export const GetEstablishmentsByUser = "/Institution/UserEstablishments";
export const GetEstablishments = "/Institution/Establishments";
// USER VIEWS DASHBOARD
export const UserViewsGlobal = "/User/ViewsGlobal";
export const UserViewDiskSpace = "/User/ViewDiskSpace";
export const UserViewNumberUsers = "/User/ViewNumberUsers";
export const UserViewUsageLevels = "/User/ViewUsageLevels";
export const UserViewsClinical = "/User/ViewsClinical";
export const UserViewNrWoundsAdmission = "/User/ViewNrWoundsAdmission";
export const UserViewAverageWounds = "/User/ViewAverageWounds";
export const UserViewTreatments = "/User/ViewTreatments";
export const UserViewUnhealedWounds = "/User/ViewUnhealedWounds";
export const UserViewWoundsHospitalization = "/User/ViewWoundsHospitalization";
export const UserViewWoundsByType = "/User/ViewWoundsByType";
export const UserViewTreatmentsAfterDate = "/User/ViewTreatmentsAfterDate";
export const UserViewAveragePain = "/User/ViewAveragePain";
export const UserViewWoundsTypeDiagnosis = "/User/ViewWoundsTypeDiagnosis";
export const UserViewWoundsTypeGender = "/User/ViewWoundsTypeGender";
export const UserViewNrDelayedTreatments = "/User/ViewNrDelayedTreatments";

// REPORTS
export const urlReportPatientDetails = "/Report/PatientDetails";
export const urlReportIntervention = "/Report/Intervention";
export const urlReportEvolutionGraphics = "/Report/EvolutionGraphics";
export const urlReportType = "/Report/Type";

//AZURE
export const AZURE_CONTAINER_NAME = "mpdsfotos";
export const AZURE_BLOB_NAME = "UsersPhotos";

// sessionStorage e LocalStorage
export const acessToken = "_token";
export const acessTokenRefresh = "_tokenRefresh";
export const InstitutionId = "_Institution";
export const InstitutionName = "_Institution_name";
export const InstitutionNIF = "_Institution_nif";
export const userEmail = "_mpds_Email";
export const userEmailVal = "_Email_Valid";
export const Institutions = "_mpds_Institutions";
export const loginsStorage = "_mpds_logins";
export const patientIDSel = "_patientID";
export const woundIDSel = "_woundID";
export const showClosedWounds = "_showClosedWounds";
export const showOpenWounds = "_showOpenWounds";
export const lgEmail = "LE_Email"
export const lgInstitution = "LE_Institution"
export const lgPatient = "LE_Patient"
export const settingsTab = "_settingsTab"
export const woundsTab = "_woundsTab"

// business
export const TYPE_WOUND_WITH_CATEGORY_PT = "Úlcera de pressão";
export const TYPE_WOUND_WITH_CATEGORY_EN = "Pressed ulcer";

//FreeTrial
export const freeTrial = "/User/FreeTrialUser";

// Colors Graphs
export const colorsGraphs = ['#F06292', '#9575CD', '#64B5F6', '#4DB6AC', '#FFB74D', '#FF8A65', '#84ffff', '#ccff90', '#ffa726', '#ffcdd2', '#c5cae9', '#b9f6ca', '#ffff8d', '#42a5f5', '#c8e6c9', '#b388ff']
